var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.472266,
    y: 0.4,
    width: 11.2,
    height: 11.2,
    rx: 0.6,
    stroke: "#A3A1AA",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07246 0.399902V11.5999",
    stroke: "#A3A1AA",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07207 0.399902V11.5999",
    stroke: "#A3A1AA",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.472458 8.00009L11.6725 8.00009",
    stroke: "#A3A1AA",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.472458 3.99991L11.6725 3.99991",
    stroke: "#A3A1AA",
    strokeWidth: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostInsta);
export default __webpack_public_path__ + "static/media/postInsta.cf226072.svg";
export { ForwardRef as ReactComponent };